import { render, staticRenderFns } from "./dataPanel.vue?vue&type=template&id=bbadefc2&scoped=true&"
import script from "./dataPanel.vue?vue&type=script&lang=js&"
export * from "./dataPanel.vue?vue&type=script&lang=js&"
import style0 from "./dataPanel.vue?vue&type=style&index=0&id=bbadefc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbadefc2",
  null
  
)

export default component.exports